import { useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { Copyright } from '../../Copyright';
import { ContactsAurea } from './Contacts';
import {
  CompanyInfoStyled,
  FooterStyled,
  IconStyled,
} from './FooterAurea.styles';

export const FooterAurea = ({ id, className }) => {
  const currentTheme = useTheme();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <>
      <FooterStyled id={id ?? 'footer'} className={className ?? null}>
        {isDesktop && (
          <CompanyInfoStyled>
            <IconStyled iconI={currentTheme.customLogo.clogo} />
          </CompanyInfoStyled>
        )}
        <ContactsAurea />
      </FooterStyled>

      <Copyright />
    </>
  );
};

FooterAurea.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};
